var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tv-display-group"},_vm._l((_vm.displays),function(d,index){return _c('TVDisplay',{key:index,attrs:{"index":d.index,"size":d.size,"channel":d.channel,"controls":_vm.controls,"hiderawvid":_vm.hideVideos}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }